export type File = (() => void) | string;

export function createWorker(file: File) {
  if (typeof file === 'string') {
    const blob = new Blob([file], { type: 'text/javascript' });
    return new Worker(URL.createObjectURL(blob));
  }
  return new (file as any)() as Worker;
}
